export const batterySwapSteps = {
  REQUEST_REJECTED: 0,
  REQUEST_CREATED: 1,
  SELECT_AGENT: 3,
  REQUEST_ACCEPTED_AGENT: 5,
  REQUEST_COMPLETED_AGENT: 6,
  SELECT_HUB: 7,
};

export const BATTERIES = [
  {
    id: "20221203",
    slot: "A1",
    percentage: 77,
  },
  {
    id: "06417047",
    slot: "A5",
    percentage: 65,
  },
  {
    id: "1395647",
    slot: "B3",
    percentage: 64,
  },
  {
    id: "KSC0376",
    slot: "C2",
    percentage: 36,
  },
  {
    id: "20221204",
    slot: "E5",
    percentage: 36,
  },
  {
    id: "KSC0064",
    slot: "C6",
    percentage: 32,
  },
  {
    id: "13457195",
    slot: "D3",
    percentage: 25,
  },
];

export const DUMMY_AGENTS = [
  {
    id: 1,
    value: "James Mwangi",
  },
  {
    id: 2,
    value: "Aisha Hassan",
  },
  {
    id: 3,
    value: "John Kamau",
  },
];
